import { HighchartsReactRefObject } from "highcharts-react-official";
import { RefObject, useEffect, useState } from "react";

export const useChartSizes = (
  chartRef: RefObject<HighchartsReactRefObject>,
  widgetContentRef: RefObject<HTMLDivElement> | null,
  isFullscreen: boolean,
) => {
  // keep state for chart height to force the graph to resize on fullscreen
  const [chartHeight, setChartHeight] = useState(() => {
    return widgetContentRef?.current?.offsetHeight;
  });

  useEffect(() => {
    setChartHeight(widgetContentRef?.current?.offsetHeight);
  }, [isFullscreen]);

  return chartHeight;
};
